export default __webpack_public_path__ + "static/media/cross_red.4567c555.svg";